// --------------------------------------------------------------------------------
export const SET_WAITING_APPROVED_COUNT = "SET_WAITING_APPROVED_COUNT";
export const SET_WAITING_APPROVED_COUNT_SUCCESS =
  "SET_WAITING_APPROVED_COUNT_SUCCESS";
